import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postCategory } from "../api";

export const useCreateCategory = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postCategory,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["CATEGORY"] });
      router("/category");
      toast.success("Success Create Category");
    },
  });

  return { create: mutate, isPending };
};
